export const ENERGYMONITORINGFILTERDROPDOWN = [
    { label: "Voyage's Only", value: "voyage" },
    { label: "Portstay's Only", value: "portstay" },
    { label: "All", value: "all" }
]

export const energyconsumptionHeaders = {
    fuelAmountConsidered_MT: "Fuel amount considered (MT)",
    fuelAmount_MT: "Fuel amount (MT)",
    electricityAmount_MWh: "Electricity amount (MWh)",
    energyAmountConsidered_GJ: "Energy amount Considered (GJ)",
    energyAmount_GJ: "Energy amount (GJ)",
    wttCO2eq_MT: "WtT CO2eq (MT)",
    ttwCO2eq_MT: "TtW CO2eq (MT)",
    wttGHGIntensity_gCO2eqPerMJ: "WtT GHG Intensity (g CO2eq/MJ)",
    ttwGHGIntensity_gCO2eqPerMJ: "TtW GHG Intensity (g CO2eq/MJ)",
    ghgIntensity_gCO2eqPerMJ: "GHG Intensity (g CO2eq/MJ)",
    ghgTarget_gCO2eqPerMJ: "GHG Target (g CO2eq/MJ)",
    complianceBalance_MTCO2eq: "Compliance Balance (MT CO2eq)",
};